var PropType = {};
if (process.env.NODE_ENV !== 'production') {
  PropType = {};
}
export var ToolbarPropTypes = PropType;